import React, { useCallback } from 'react'
import { useRouter } from 'next/navigation'
import { FormResponse } from '../utils/form'

const createThanksPath = (to: string) => {
  const path = location.pathname.split('/')
  if (path[0] === '') {
    path.splice(0, 1)
  }
  if (path[path.length - 1] === '') {
    path.splice(path.length - 1, 1)
  }
  const p = `${to}?from=${path.join('-')}`
  return p
}

// isSuccessCondition関数の型定義を追加
type SuccessConditionFunc = (json: any, res: Response) => boolean

export const useSendApi = (
  apiPath: string,
  thanksPagePath: string,
  isSuccessCondition?: SuccessConditionFunc
) => {
  const router = useRouter()
  const [isSendError, setIsSendError] = React.useState(false)
  const sendApi = useCallback(
    async (body: string) => {
      setIsSendError(false)

      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_FORM_ENDPOINT}${apiPath}`,
          {
            method: 'POST',
            mode: 'cors',
            body,
          }
        )
        const json = (await res.json()) as FormResponse

        // Default success condition
        let isSuccess = json.success && res.status === 200

        // Custom success condition if provided
        if (isSuccessCondition) {
          isSuccess = isSuccessCondition(json, res)
        }

        if (!isSuccess) {
          console.error('API Error:', json)
          throw new Error(
            'API response indicates failure: ' + JSON.stringify(json)
          )
        }

        location.href = createThanksPath(thanksPagePath)
      } catch (e) {
        setIsSendError(true)
      }
    },
    [apiPath, isSuccessCondition, thanksPagePath]
  )

  return {
    isSendError,
    sendApi,
  }
}
